import { render, staticRenderFns } from "./CommentFormRead.vue?vue&type=template&id=414cf497&"
import script from "./CommentFormRead.vue?vue&type=script&lang=js&"
export * from "./CommentFormRead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports